import type { ReactNode, Ref } from 'react';
import ButtonAction from '../../interfaces/buttonAction';
import BreakLine from '../commons/break-line';
import NavigationFooter from '../navigation-footer';
import * as styles from './Layout.module.css';

interface LayoutProps {
  children: ReactNode;
  backButton: ButtonAction;
  nextButton: ButtonAction;
  ref?: Ref<HTMLDivElement>;
}

const Layout = ({ children, backButton, nextButton, ref }: LayoutProps) => {
  return (
    <>
      <div ref={ref} className={styles.appContainer}>
        <BreakLine />
        {children}
        <NavigationFooter backButton={backButton} nextButton={nextButton} />
      </div>
    </>
  );
};

export default Layout;
